export const CourseCardSkeleton = () => {
  return (
    <div className="flex min-w-72 flex-col rounded-2xl border border-lines bg-white px-4 py-6">
      <div className="flex flex-row items-center gap-3">
        <div className="h-10 w-10 animate-pulse rounded-full bg-mydra-mouse" />
        <div className="h-4 w-32 animate-pulse rounded bg-mydra-mouse" />
      </div>

      <div className="relative mt-4 aspect-[2.16] w-full">
        <div className="h-full w-full animate-pulse rounded-lg bg-mydra-mouse" />
      </div>

      <div className="mt-5 space-y-2">
        <div className="h-5 w-full animate-pulse rounded bg-mydra-mouse" />
        <div className="h-5 w-3/4 animate-pulse rounded bg-mydra-mouse" />
      </div>

      <div className="mt-6 flex flex-row gap-2">
        <div className="h-6 w-20 animate-pulse rounded bg-mydra-mouse" />
        <div className="h-6 w-20 animate-pulse rounded bg-mydra-mouse" />
      </div>

      <div className="mt-4">
        <div className="h-5 w-24 animate-pulse rounded bg-mydra-mouse" />
      </div>
    </div>
  )
}
